import React from "react";
import { Refresh } from "@bloomberg/media-ui-icons";
import styles from "./styles.module.css";

export interface TableErrorStateProps {
  readonly onRefresh: () => void;
}

export default function TableErrorState({ onRefresh }: TableErrorStateProps) {
  return (
    <div className={styles.container} role="alert">
      <div className={styles.content}>
        <p className={styles.message}>
          There was a network error.
          <br />
          Please try again.
        </p>
        <button
          className={styles.refreshButton}
          onClick={onRefresh}
          type="button"
        >
          <span className={styles.refreshIcon}>
            <Refresh />
          </span>
          Refresh
        </button>
      </div>
    </div>
  );
}
